import {useEffect, useMemo, useState} from 'react';
import {useSelecteSubscription} from '@src/Store/selectors/useMember';
import {auth} from '@src/firebase';

export const VODACOM_HOSTNAME = 'vc.trace.plus';

export const isVodacomHostname = (): boolean =>
  typeof window !== 'undefined' &&
  window.location.hostname.toLowerCase() === VODACOM_HOSTNAME;

/**
 * Detect Vodacom carrier user via subscription carrier, Firebase claims,
 * or vc.trace.plus hostname. Works even when subscription has expired.
 */
export const useIsVodacomUser = (): boolean => {
  const memberSubscription = useSelecteSubscription();
  const [claimCarrier, setClaimCarrier] = useState<string | undefined>();

  useEffect(() => {
    const user = auth.currentUser;
    if (user) {
      user.getIdTokenResult(false).then(result => {
        const carrier = result.claims?.carrier as string | undefined;
        setClaimCarrier(carrier);
      }).catch(() => {});
    }
  }, [auth.currentUser?.uid]);

  return useMemo(() => {
    if (memberSubscription?.carrier === 'vodacom') return true;
    if (claimCarrier === 'vodacom') return true;
    if (isVodacomHostname()) return true;
    return false;
  }, [memberSubscription?.carrier, claimCarrier]);
};

export default useIsVodacomUser;
